// // TODO move to NNSIMPLEJS
// export function appendQuerySting(url, qs) {
// 	return (url.includes('?') ? `${url}&${qs}` : `${url}?${qs}`);
// }
//
// // TODO move newURL to NNSIMPLEJS
// export const newURL = (l => {
// 	try {
// 		return new URL(l);
// 	} catch (e) {
// 	}
// 	return null;
// });

// das ist eine Art selector auf die von react-router bereitgestellte location
// navPosition kann bei withRouter(connect()) beim connect in der mapStateToProps auf ownProps.location angewendet werden

const navPositionCache = {};

/**
 * @param {import('../types').Magic} magic
 * @param {string} path
 * @param [any] urlState
 *
 */

/**
 * @param {import('../types').Magic} magic
 * @param {string} path
 * @param {any} [urlState]
 * @returns {{
 *   error404: boolean,
 *   map: boolean,
 *   list: boolean,
 *   listMorePoi: boolean,
 *   haveMorePoi: boolean,
 *   home:  boolean,
 *   deepLink: string,
 *   withStarsRating: boolean,
 *   app?: import('../../stade/types').App,
 * }}
 */
export function navPosition(magic, path, urlState) {
	if (navPositionCache.result && navPositionCache.magic === magic && navPositionCache.path === path && navPositionCache.state === urlState) {
		return navPositionCache.result;
	}
	navPositionCache.magic = magic;
	navPositionCache.path = path;
	navPositionCache.state = urlState;

	const pathname = path
		.replace(/\/+$/, '')  // notwendig
		.replace(/index.html$/, '');  // notwendig

	let result = {
		error404: true
	};

	(magic.apps || []).forEach(element => {
		if (
			pathname.startsWith(element.url) &&
			(element.url.length === pathname.length || pathname.startsWith('/', element.url.length))
		) {
			result = {
				app: element,
				deepLink: pathname.substr(element.url.length + 1), // +1 to remove leading / tested for above,
				haveMorePoi: element.uri.startsWith('kinder'), // this is a hack but it's cheaper than adding a property to magic
				error404: false,
				state: urlState,
			};
			// no slash in deep-links. ie. no deeper areas
			if(result.deepLink && result.deepLink.indexOf('/') >= 0) {
				result.error404 = true;
				// result = {
				// 	app: element,
				// 	deepLink: '',
				// 	error404: true,
				// };
			}

			// TODO check if poi with id exists
			// but that would need access to the geojsons, which are in the app store and not reachable here
		}
	});

	if (
		(result.app?.lang === 'de' && result.deepLink === 'karte') ||
		(result.app?.lang === 'en' && result.deepLink === 'map')
	) {
		result.map = true;
		result.deepLink = null;
		result.error404 = false;
	} else if (
		(result.app?.lang === 'de' && result.deepLink === 'liste') ||
		(result.app?.lang === 'en' && result.deepLink === 'list')
	) {
		result.list = true;
		result.deepLink = null;
		result.error404 = false;
	} else if (result.app?.lang === 'de' && result.haveMorePoi && result.deepLink === 'poi-liste') {
		result.listMorePoi = true;
		result.deepLink = null;
		result.error404 = false;
	} else if (result.app && !result.deepLink) {
		result.home = true;
		result.error404 = false;
	}

	// TODO Stade: remove this in 2024 when user ratings go to production
	// till then it has to be false in the repo, only enbale it in local dev builds
	result.withStarsRating = false;

	navPositionCache.result = result;

	// console.warn('navPosition', {
	// 	result,
	// 	magic,
	// 	path,
	// 	calculatedPath: pathname,
	// 	urlState,
	// });

	return result;
}

// maybe useful, should go to store/selectors.js
// export const reduceToLayerIdsSetVisible = (layers) => (layers ?
// 		Object.keys(layers).reduce(
// 			(acc, layerId) => (
// 				layers[layerId].options.visible ? [...acc, layerId] : acc
// 			),
// 			[]
// 		) : []
// );
